import { generateId } from 'core-components/helpers/generateId'
import { CONDITION_PREFIX, GROUP_PREFIX, ICondition, IGroup } from 'core-components/library/filter'
import { IDataProviderFilter, IFilter } from 'core-components/types'

const getFiltersWithIds = (
  filters: Array<IDataProviderFilter | IFilter>
): Array<IGroup | ICondition> => {
  return filters.map((filter) => {
    if ('field' in filter) {
      return { ...filter, id: generateId(CONDITION_PREFIX) }
    }
    return {
      id: generateId(GROUP_PREFIX),
      logic: filter.logic,
      filters: getFiltersWithIds(filter.filters),
    }
  })
}

const getFilterWithoutIds = (
  groups: Array<IGroup | ICondition>
): Array<IDataProviderFilter | IFilter> => {
  return groups.map((filter) => {
    if ('field' in filter) {
      return {
        field: filter.field,
        operator: filter.operator,
        value: filter.value,
      }
    }
    return {
      logic: filter.logic,
      filters: getFilterWithoutIds(filter.filters),
    }
  })
}
const checkEmpty = (checkObj: IDataProviderFilter | IFilter): boolean => {
  const isGroup = 'filters' in checkObj
  if (isGroup) {
    return checkObj.filters.some((el) => {
      return checkEmpty(el)
    })
  }

  return !checkObj.field || !checkObj.operator || !checkObj.value
}

export const checkEmptyFields = (group: IDataProviderFilter): boolean => {
  return group.filters.some((el) => {
    return checkEmpty(el)
  })
}

export const parseFilterToGroups = (filter: IDataProviderFilter): IGroup => {
  const filterWithIds = getFiltersWithIds(filter.filters)
  return { id: generateId(GROUP_PREFIX), logic: filter.logic, filters: filterWithIds }
}

export const parseGroupsToFilter = (group: IGroup): IDataProviderFilter => {
  const filterWithoutIds = getFilterWithoutIds(group.filters)
  return {
    logic: group.logic,
    filters: filterWithoutIds,
  }
}
